export const preloadImages = (urls) => {
  urls.forEach(src => {
    if (!src) return;
    const img = new Image();
    img.src = src;
  });
};
